import styled from 'styled-components';


export const NoResultView = styled.div`
height: 10vh;
width: 100%;
display:flex;
justify-content:center;
align-items:center;
`


